import { Head, Link } from '@inertiajs/react'
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"
import Form from './Form'

interface Props {
  deal: {
    id: number
    name: string
  }
  suppliers: Array<{
    id: number
    name: string
  }>
  errors?: Record<string, string>
}

export default function New({ deal, suppliers, errors = {} }: Props) {
  return (
    <>
      <Head title={`New Award - ${deal.name}`} />
      <div className="container mx-auto py-6 space-y-6">
        <div className="flex items-center space-x-4">
          <Link href={`/deals/${deal.id}`}>
            <Button variant="outline" size="icon">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </Link>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">New Award</h1>
            <p className="text-sm text-muted-foreground">
              Deal: {deal.name}
            </p>
          </div>
        </div>

        <Form deal={deal} suppliers={suppliers} errors={errors} />
      </div>
    </>
  )
}
